import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getProjectBridgeResolution = api(async function projectBridgeResolution({ id }) {
    if (!id) return null

    return query(
        gql`
            query GetProjectBridgeResolution($id: ID!) {
                projectBridgeResolution(id: $id)
            }
        `,
        { id },
        { returns: "projectBridgeResolution" }
    )
})
